import { useState } from "react";
import AuthLayout from "../components/AuthLayout";
import Button from "../components/Button";
import Checkbox from "../components/Checkbox";
import TextField from "../components/TextField";
import styles from "./AuthForm.module.css";

export default function LoginPage({ onLogin, onNavigate }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (submitting) {
      return;
    }
    setSubmitting(true);
    setError(null);
    const result = await onLogin({ email, password });
    // On success App navigates away and this page unmounts
    if (result?.error) {
      setError(result.error);
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout title="Log in">
      <form className={styles.form} onSubmit={handleSubmit}>
        <TextField
          label="Email"
          type="email"
          autoComplete="username"
          required
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        <TextField
          label="Password"
          type={showPassword ? "text" : "password"}
          autoComplete="current-password"
          required
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
        <div className={`${styles.options} d-flex align-items-center justify-content-between flex-wrap`}>
          <Checkbox
            label="Show password"
            checked={showPassword}
            onChange={(event) => setShowPassword(event.target.checked)}
          />
          <button type="button" className={styles.forgot} onClick={() => onNavigate("/forgot-password")}>
            Forgot password?
          </button>
        </div>
        {error ? (
          <p className={styles.error} role="alert">
            {error}
          </p>
        ) : null}
        <Button type="submit" disabled={submitting}>
          {submitting ? "Logging in…" : "Log in"}
        </Button>
      </form>
    </AuthLayout>
  );
}
